import type { FlagVariant } from '@lib/flags';
import { FLAG_TREATMENT_QS, FLAG_TREATMENT_UA } from '@lib/flags/flagConstants';

export type TrendingSource = 'qs' | 'ua';

/**
 * The trending-searches arm (`as-trending-search`, CPS-8004) a variant puts
 * the shopper in. Anything but a named treatment — control, the generic
 * `treatment`, a missing flag — is no arm at all, which is today's box. Falls
 * back to `key` because variants resolved through the REST client carry no
 * `value`.
 */
export const resolveTrendingSource = (
  variant: FlagVariant | undefined
): TrendingSource | null => {
  switch (variant?.value ?? variant?.key) {
    case FLAG_TREATMENT_QS:
      return 'qs';
    case FLAG_TREATMENT_UA:
      return 'ua';
    default:
      return null;
  }
};
